module.exports = __webpack_public_path__ + "static/media/Arrow-down-white.6ab7f69a.svg";